import { featurePath } from '@/features/marketing/nav';
import { registerSiteContent } from '@/features/siteContent/runtime';

/**
 * The marketing footer. Editable by the platform owner under Site content ->
 * Footer.
 *
 * The reference design also listed a help centre, a blog, guides, success
 * stories and careers. None of those pages exist, so they are left out rather
 * than shipped as links that land on the 404 page - the column headings match
 * the design, the links under them go somewhere real.
 */
export const FOOTER_COLUMNS = [
  {
    heading: 'Products',
    links: [
      { label: 'Online store', to: featurePath('online-store') },
      { label: 'WhatsApp Commerce', to: featurePath('whatsapp-commerce') },
      { label: 'Payments', to: featurePath('payments') },
      { label: 'Checkout', to: featurePath('checkout') },
      { label: 'Analytics & insights', to: featurePath('analytics') },
      { label: 'AI assistant', to: featurePath('ai-assistant') },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'Why NeonCarts', to: '/why-shoplaunch' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'Enterprise', to: '/enterprise' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { label: 'Video help centre', to: '/help' },
      { label: "Today's Deals", to: '/deals' },
      // The only public door into the affiliate programme, so it belongs
      // somewhere a person who has not signed up can find it.
      { label: 'Become a partner', to: '/become-a-partner' },
      { label: 'Talk to sales', to: '/talk-to-sales' },
    ],
  },
  {
    heading: 'Get started',
    links: [
      { label: 'Create your store', to: '/register' },
      { label: 'Log in', to: '/login' },
    ],
  },
];

export const FOOTER_TEXT = {
  blurb:
    'AI Commerce OS for Indian businesses. Launch your online store, sell on WhatsApp and grow with AI.',
  strapline: 'GST-ready invoices · UPI, cards and COD · Made in India',
  /** `{year}` is filled with the current year. */
  copyright: '© {year} NeonCarts. All rights reserved.',
};

/**
 * The social row, empty until there are accounts to point it at. The icon is
 * picked from the address (Instagram, Facebook, YouTube, LinkedIn, X/Twitter);
 * an icon linking to `#` would be a button that does nothing, so an entry
 * without an address is not shown.
 */
export const SOCIAL_LINKS: { label: string; href: string }[] = [];

registerSiteContent(
  'footer',
  { FOOTER_TEXT, FOOTER_COLUMNS, SOCIAL_LINKS },
  { SOCIAL_LINKS: { label: 'Instagram', href: 'https://instagram.com/' } },
);
